import requestModifiedImageOperation from '../../plugins/operation/imageManipulation/requestModifiedImageOperation';
import { MediaElement, MediaImage } from '../types';

const requestImageUpscaleOperation = (element: MediaElement) => {
  return (dispatch: any, getState: any) => {
    if (element.type === 'image') {
      if (typeof element.pw === 'number' && typeof element.ph === 'number' && element.pw > 0 && element.ph > 0) {
        const pixelCount = element.pw * element.ph;
        const GPU_PIXEL_LIMIT = 2096704; // Based on GPU memory constraints from replicate error

        if (pixelCount > GPU_PIXEL_LIMIT) {
          return Promise.resolve();
        }
      }
    }

    return requestModifiedImageOperation({
      elementId: element.uuid,
      pluginName: 'app-image-upscale',
      assetId: (element as MediaImage).imageId,
      preview: false,
    })(dispatch, getState);
  };
};

export default requestImageUpscaleOperation;
